import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { BaseService } from './base.service';
import { VariableTransformer } from '../utils/transformers/variable.transformer';
import * as ApiVariable from '../interfaces/api/variable';
import { VariableCode } from '../enums/variable-code';

@Injectable({
  providedIn: 'root',
})
export class VariableService extends BaseService {
  constructor(private http: HttpClient, private variableTransformer: VariableTransformer) {
    super();
  }

  findVariable(code: string) {
    return this.http
      .get<ApiVariable.ResponseBody>(`${this.apiUrl}/variable/${code}`)
      .pipe(map(data => data.variable));
  }

  getVariableService() {
    return this.http
      .get<ApiVariable.ResponseBodyArray>(`${this.apiUrl}/variable/type/service`)
      .pipe(map(data => data.variables));
  }

  getVariablePolicy() {
    return this.http
      .get<ApiVariable.ResponseBodyArray>(`${this.apiUrl}/variable/type/policy`)
      .pipe(map(data => data.variables));
  }

  getBankPaymentMethods() {
    return this.http
      .get<ApiVariable.ResponseBodyBankArray>(`${this.apiUrl}/bank`)
      .pipe(map(data => data.banks));
  }

  getHomeMenuVariable(){
    return this.http
    .get<ApiVariable.ResponseBodyArray>(`${this.apiUrl}/home_menu_settings`)
  }
}
